import React from 'react';
import OverlayContainer from '../OverlayContainer';
import Img from './Img';

export default function BottomModal({ isOpen, onClose, title, children, id = "xs-bottom-sheet" }) {
    if (!isOpen) return null;

    return (
        <OverlayContainer id={id} container={'xs-drawer-container'}>
            <div className="c_86" role="dialog" aria-modal="true">
                <div className="c_86_1" onClick={onClose}></div>
                <div className="c_86_2">
                    <div className="c_86_2_1">
                        <div className="c_86_2_1_1">{title}</div>
                        <Img className="c_23_1_2" src="close.svg" height="16px" width="16px" onClick={onClose} />
                    </div>
                    <div className="c_86_2_2">
                        {children}
                    </div>
                </div>
            </div>
        </OverlayContainer>
    );
}